export const MAX_INGREDIENT_IMAGE_BYTES = 8 * 1024 * 1024;
export const INGREDIENT_IMAGE_FIELD_NAME = "image";
export const ALLOWED_INGREDIENT_IMAGE_MIME_TYPES = [
    "image/jpeg",
    "image/png",
    "image/webp",
];
export const ALLOWED_INGREDIENT_IMAGE_EXTENSIONS = [
    ".jpg",
    ".jpeg",
    ".png",
    ".webp",
];
const allowedMimeSet = new Set(ALLOWED_INGREDIENT_IMAGE_MIME_TYPES);
const allowedExtSet = new Set(ALLOWED_INGREDIENT_IMAGE_EXTENSIONS);
export function isAllowedIngredientImageMime(mime) {
    return allowedMimeSet.has(mime);
}
export function isAllowedIngredientImageExtension(ext) {
    return allowedExtSet.has(ext.toLowerCase());
}
//# sourceMappingURL=ingredientsContracts.js.map